import request from "../../utiles/axios";

/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(data) {
  return request({
    url: "/dept/deptTree",
    method: "post",
    data: data,
  });
}
/**
 * 新增修改机构
 * @param {*} data
 * @returns
 */
export function saveOrUpdate(data) {
  return request({
    url: "/dept/saveOrUpdate",
    method: "post",
    data: data,
  });
}
/**
 * 机构启用/禁用切换
 * @param {*} data
 * @returns
 */
export function updateEnableFlag(data) {
  return request({
    url: "/dept/updateEnableFlag",
    method: "post",
    data: data,
  });
}


export function deptTreeByCompCode(compCode) {
  return request({
    url: `/dept/deptTreeByCompCode?compCode=${compCode}`,
    method: "post",
  });
}


  /**
   * 查询租户配置
   */
  export function getCompanyOption(compCode) {
    return request({
      // url: "/companyOption/getCompanyOption?compCode=" + compCode ,
      url: `/companyOption/getCompanyOption/${compCode}`,
      method: "get",
    });
  }